import React from 'react';
import { Collapse } from 'reactstrap';

import { UiKit } from 'components';
import { usePreferredCarrier } from '../context';

export default function Form({ isDisabled = false }) {
  const {
    data,
    slaOptions,
    isProcessing,
    errors,
    onChange
  } = usePreferredCarrier();

  const disabled = isProcessing || isDisabled;

  return (
    <UiKit.Radio.Group
      gap={12}
      value={data.is_enabled}
      onChange={value => onChange({ is_enabled: value })}
      disabled={disabled}
      error={errors.is_enabled}
    >
      <UiKit.Radio.Card label="Cheapest" value={false} labelWeight="bold">
        <UiKit.Text variant={600}>
          Automatically use the lowest-cost option from your enabled services
        </UiKit.Text>
      </UiKit.Radio.Card>
      <UiKit.Radio.Card
        label="Specific service"
        value={true}
        labelWeight="bold"
      >
        <UiKit.Text variant={600}>
          Always use a specific carrier and service
        </UiKit.Text>
        <Collapse isOpen={data.is_enabled}>
          <UiKit.Separator className="my-2" />
          <UiKit.Grid gap="16" templateColumns="1fr 1fr">
            <UiKit.Select
              label="Service"
              options={slaOptions}
              value={data.sla}
              onChange={sla => onChange({ sla })}
              placeholder="Choose a specific service"
              isDisabled={disabled}
              error={errors.sla}
            />
          </UiKit.Grid>
        </Collapse>
      </UiKit.Radio.Card>
    </UiKit.Radio.Group>
  );
}
